export const ReCAPTCHA_KEY = "6Lc6CX0cAAAAAFdQJ0Cb5eYvqbnQHc2k-zlJGp7C";
